import React, { Component } from "react";
import DialogFooterViewProps from './DialogFooterViewProps';
import DialogFooterViewStyle from './DialogFooterViewStyle';
import ButtonView from "../../../../../../components/button/ButtonView";
import DialogFooterViewState from './DialogFooterViewState';
import DialogErrorTextView from "../DialogErrorText/DialogErrorTextView";
import TranslationView from "../../../../../../components/translation/TranslationView";

export default class DialogFooterView extends Component<DialogFooterViewProps, DialogFooterViewState> {

    private _style = new DialogFooterViewStyle();

    state = {
        busy: false
    };

    render() {
        return (
            <div style={this._style.dialogFooter}>
                <DialogErrorTextView>
                    {this.props.error &&
                        <TranslationView>
                            {this.props.error}
                        </TranslationView>
                    }
                </DialogErrorTextView>

                <ButtonView width={100} onClick={this.onSubmit} isBusy={this.state.busy}>
                    send
                </ButtonView>
            </div>
        );
    }

    onSubmit = () => {
        this.setState({
            busy: true
        });

        this.props.onSubmit(() => {
            this.setState({
                busy: false
            });
        });
    }
}